<!-- Sidebar (next-gen UI) -->
@if ((isNextGen$ | async) && !isStandaloneRoute) {
  <sidebar
  (sidebarToggled)="onSidebarToggle($event)"></sidebar>
}

<!-- Top Nav (next-gen UI) - shown at app level when next-gen is enabled -->
@if ((isNextGen$ | async) && !isStandaloneRoute && !isCampaignDetailsRoute && !(isMobile$ | async)) {
  <div class="spotlight-app__top-nav-wrapper"
    [class.spotlight-app__top-nav-wrapper--collapsed]="sidebarCollapsed">
    <navbar [showSelectedLocationName]="showSelectedLocationName"
      [showLocationNumber]="showLocationNumber"
    [selectedIndex]="selectedNavIndex"></navbar>
  </div>
}

<!-- Main Content Wrapper -->
<div class="spotlight-app__content"
  [class.spotlight-app__content--with-sidebar]="(isNextGen$ | async) && !isStandaloneRoute && !(isMobile$ | async)"
  [class.spotlight-app__content--sidebar-collapsed]="sidebarCollapsed && (isNextGen$ | async) && !isStandaloneRoute && !(isMobile$ | async)"
  [class.spotlight-app__content--with-mobile-header]="(isNextGen$ | async) && !isStandaloneRoute && (isMobile$ | async)">

  @if (!isStandaloneRoute) {
    @if (userError$ | async; as userError) {
      <error-message
        [error]="userError"
        [page]="'User'">
      </error-message>
    }
    @if (locationError$ | async; as locationError) {
      <!-- Legacy UI: the navbar lives inside each page (hidden below), so render it here
           to keep the location selector reachable. -->
      @if (!(isNextGen$ | async)) {
        <navbar [showSelectedLocationName]="true"
          [selectedIndex]="selectedNavIndex"></navbar>
      }
      <error-message
        [error]="locationError"
        [page]="'Location'">
      </error-message>
    }
  }

  <div class="spotlight-app__router-wrapper"
    [cfaLoading]="(locationLoading$ | async) && !isStandaloneRoute"
    [ngClass]="{'spotlight-app__router-wrapper-blue' : isBlueBackground}"
    [ngStyle]="{'min-height': (minimumPageHeight$ | async) + 'px' }"
    [@slideUpAnimation]="prepareRoute$(outlet) | async">
    <div [hidden]="((locationLoading$ | async) || (userError$ | async) || (locationError$ | async)) && !isStandaloneRoute">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  </div>

  <spot-footer></spot-footer>
</div>
